module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day02_05_stay-a45d6e844dcb3b844501a6f1397f64e9.jpg";